import i18n from 'i18next';

export const isKeyExistInI18n = (key: string) => i18n.exists(key);
export const DEFAULT_ERROR_CODE = '500';
export const DEFAULT_SUBTITLE = 'Oops! Something went wrong';
export const DEFAULT_DESCRIPTION =
  'Sorry, this may be because the page is still under development or there is a problem with the server. Please try again later.';
export const DEFAULT_BUTTON_TEXT = 'Go Back';
